import styled from 'styled-components';
import { infoColor, grayColor } from "~/components/layout/Variables";

export const SubTitle = styled.p`
  color: ${() => grayColor};
  font-size: .95rem;
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(max-width: 770px) {
    margin: 0rem 0rem 0.2rem 0rem;
  }
`;

export const ButtonDivision = styled.div`
  margin: 2rem auto 3.5rem auto;
  width: 50%;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const CardHeader = {
  alignItems: "center",
  backgroundColor: "rgb(230, 223, 223)",
  boxShadow: "0px 2px 4px #00000033",
  color: "rgb(112, 112, 112)",
  display: "flex",
  fontSize: ".9rem",
  fontWeight: "550",
  justifyContent: "space-between",
  padding: ".2rem 1rem",
};

export const CardInput = styled.div`
  margin: 0rem 0rem 0rem 0rem;
`;

export const CardInputItem = styled.div`
  margin: 0rem 1rem 0rem 1rem;
`;

export const CloseIconStyled = styled.img`
  cursor: pointer;
  height: 10%;
  margin-left: 0.5rem;
  position: relative;
  width: 10%;

  @media (min-width: 420px) {
    height: 8%;
    width: 8%;
  }

  @media (min-width: 500px) {
    height: 6%;
    width: 6%;
  }

  @media (min-width: 1000px) {
    height: 28px;
    margin-top: 19px;
    width: 28px;
  }
`;

export const InputQuantity = styled.input`
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  box-shadow: 0px 2px 2px #00000029;
  color: #808080;
  margin: 0.7rem 0rem;
  padding: 0.3rem 0rem;
  text-align: center;
  width: 100%;
`;

export const LeftItemQuantity = styled(SubTitle)`
  font-weight: bold;
  margin: 0.3rem 0.5rem 0.3rem 0rem;
  text-align: left;
  width: 100%;
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const Product = styled.span`
  color: ${() => infoColor};
  display: flex;
  font-size: 1.1rem;
  justify-content: left;
  max-height: 3rem;
`;



export const TextQuantity = styled(SubTitle)`
  margin: 1rem 0rem 0rem;
  text-align: left;

  @media(max-width: 770px) {
    margin: 1rem 0rem 0rem;
  }
`;

export const Title = styled.h2`
  align-items: center;
  color: ${() => grayColor};
  display: flex;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 1rem 0 0 0;

  @media(min-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const TitlePage = styled.h1`
  align-items: center;
  color: white;
  display: flex;
  font-size: 1.3rem;
  font-weight: 200;
  justify-content: space-between;
  margin-bottom: -0.7rem;
  padding-top: 2rem;
  text-align: center;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin-right: 1rem;
    }
  }
`;
